import type { SegmentedOption } from './SegmentedToggle';

export type OpenNowMode = 'now' | 'plan';

// Planned by default: opening at once is a deliberate choice, and the only one outside treatment.
export const DEFAULT_OPEN_NOW_MODE: OpenNowMode = 'plan';

export function openNowModeOptions(canOpenNow: boolean): SegmentedOption<OpenNowMode>[] {
    return [
        { value: 'now', label: 'Open now', disabled: !canOpenNow },
        { value: 'plan', label: 'Plan' }
    ];
}

export interface WeeksStartFacts {
    treatmentStartDate: string | null;
    canOpenNow: boolean;
}

// Mirrors the backend: only in the Treatment phase does a missing start mean none on record.
export function weeksStartUnavailable({
    treatmentStartDate,
    canOpenNow
}: WeeksStartFacts): boolean {
    return canOpenNow && treatmentStartDate === null;
}
